import React from "react";

import { Caption, Flex } from "@olist/design-system";

import { WelcomeName, WelcomeTitle } from "./styles";

interface WelcomeStepProps {
  theme?: "light" | "dark";
}

export function WelcomeStep({ theme }: WelcomeStepProps) {
  return (
    <Flex
      flexDirection="column"
      paddingTop="stack.huge"
      paddingBottom="stack.huge"
      justifyContent="flex-start"
      height="100%"
    >
      <Flex
        flexDirection="column"
        gap="24px"
        height="100%"
        justifyContent="center"
      >
        <WelcomeName DSTheme={theme}>
          Olá, eu sou o assistente virtual
        </WelcomeName>
        <WelcomeTitle
          color={theme === "dark" ? "neutral.soft" : "neutral.base"}
        >
          Como posso te ajudar hoje?
        </WelcomeTitle>
        <Caption color="neutral.base">
          Aqui você poderá resolver seu problema, abrir um chamado ou solicitar
          atendimento humano
        </Caption>
      </Flex>
    </Flex>
  );
}
